export default defineAppConfig({
	nuxtIcon: {
		size: "24px"
	}
});
